// @ts-strict-ignore
import { PublicPage } from 'api/website';
import { isDefined } from 'utils/functional';

type Props = {
  content: PublicPage;
};

export function getContentFirstRealBlockIndex({ content }: Props) {
  let firstRealBlockIndex;

  content.contentBlocks.forEach((block, i) => {
    if (!isDefined(firstRealBlockIndex) && block.type !== 'SCROLL_TRACKING') {
      firstRealBlockIndex = i;
    }
  });

  return firstRealBlockIndex;
}
